import React from "react";
import PropTypes from "prop-types";

export function ScaleComponent({ setWidth, children, width, minScaleWidth }) {
  const style = {
    width: setWidth ? `${minScaleWidth}px` : "",
    transform: `scale(${minScaleWidth / width})`,
  };
  return <div style={style}>{children}</div>;
}

ScaleComponent.propTypes = {
  /**
   * Boolean to specify if passed width should be set on component
   */
  setWidth: PropTypes.bool,
  /**
   * Child element to be displayed inside.
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * Actual width of the component
   */
  width: PropTypes.number,
  /**
   * Minimum width where the component doesnot break
   */
  minScaleWidth: PropTypes.number,
};

ScaleComponent.defaultProps = {
  setWidth: false,
};
